export default {
  computed: {
    allUsers: function () {
      return this.$store.state.UserStore.all_users
    },
    Users: function () {
      return this.$store.state.UserStore.users
    },
    singleUser: function () {
      return this.$store.state.UserStore.user
    },
    UpdateUser: function () {
      this.user.user_type = this.$store.state.UserStore.user.user_type_public_id
      this.user.first_name = this.$store.state.UserStore.user.first_name
      this.user.last_name = this.$store.state.UserStore.user.last_name
      this.user.email = this.$store.state.UserStore.user.email
      this.user.phone_number = this.$store.state.UserStore.user.phone_number
      this.user.has_account = this.$store.state.UserStore.user.has_account
      this.user.customer_code_usd = this.$store.state.UserStore.user.customer_code_usd
      this.user.customer_code_kes = this.$store.state.UserStore.user.customer_code_kes
    },

  
  }
}
